export default __webpack_public_path__ + "static/media/kitchen4-afterC-1440w.4de3cce5.png";